import clsx from "clsx"
import { formatPriceShort } from "src/utilities/price"

export type PriceShortProps = {
  price: number | undefined
  regularPrice: number | undefined
  textAlign: "left" | "center" | "right"
  size: "md" | "lg"
}

export const PriceShort = ({ price, regularPrice, textAlign, size }: PriceShortProps) => {
  if (!price) {
    return null
  }

  return (
    <div
      className={clsx("m-0 leading-none whitespace-nowrap", {
        "text-left": textAlign === "left",
        "text-center": textAlign === "center",
        "text-right": textAlign === "right",
      })}
    >
      <div
        className={clsx("flex flex-wrap items-center gap-x-2", {
          "justify-start": textAlign === "left",
          "justify-center": textAlign === "center",
          "justify-end": textAlign === "right",
        })}
      >
        <div
          className={clsx("font-product leading-none", {
            "text-h2-np": size === "lg",
            "text-h3-np": size === "md",
          })}
        >
          {formatPriceShort(price)}
        </div>

        {regularPrice && (
          <div className={clsx("leading-none line-through opacity-50")}>{formatPriceShort(regularPrice)}</div>
        )}
      </div>

      <div className="text-sm">inkl. MwSt.</div>
    </div>
  )
}
